{
  "hero": {
    "eyebrow": "学生主导的工程项目 · 加拿大温哥华",
    "title": "AquaWorks — 水质监测。",
    "subtitle": "AquaWorks 是由不列颠哥伦比亚大学学生开发的学生主导工程项目。本站位于不列颠哥伦比亚大学温哥华校园。",
    "ctaPrimary": "加入团队",
    "ctaSecondary": "了解项目",
    "legend": "雷达辅助 · 人工远程监督"
  },
  "status": {
    "items": [
      { "value": "第一阶段", "label": "建造窗口", "note": "2026 年 9–12 月" },
      { "value": "5", "label": "核心指标", "note": "温度、pH、浊度、电导率、溶解氧" },
      { "value": "4", "label": "学生子团队", "note": "软件、电气、机械、商务" },
      { "value": "2027.01", "label": "交接报告", "note": "供后续学生团队延续" }
    ]
  },
  "identity": {
    "title": "AquaWorks 是什么？",
    "body": "AquaWorks（也称 AquaWork）是由不列颠哥伦比亚大学学生开发的学生主导工程项目。本首页是 aquawork.ca 的索引，网站位于不列颠哥伦比亚大学温哥华校园，团队正在建造雷达辅助水质监测机器人。"
  },
  "pillars": {
    "title": "第一阶段交付什么",
    "lead": "面向受控静水测试的实用原型——不是宣传册，也不替代实验室分析。",
    "panels": {
      "platform": {
        "kicker": "01 / 平台",
        "title": "模块化浮体机器人",
        "body": "浮力、推进、防水电子、雷达测距辅助，以及安全岸边回收。"
      },
      "sense": {
        "kicker": "02 / 传感",
        "title": "五项水质指标",
        "body": "可更换传感器，每条记录带校准说明、时间戳与空间参考。"
      },
      "viz": {
        "kicker": "03 / 可视化",
        "title": "路线、趋势、空间",
        "body": "CSV 兼容日志转化为路线图、时序曲线，以及至少一幅空间水质可视化。"
      }
    }
  },
  "roadmap": {
    "title": "超越静水的分阶段路径",
    "lead": "第一阶段打好基础；后续阶段面向近岸与区域监测——须经许可、安全审查与额外资金。",
    "cta": "查看完整路线图"
  },
  "context": {
    "title": "为何移动监测对温哥华校园重要",
    "body": "雨水水质与降雨关联变化是校园长期优先事项。固定站点与既往 SEEDS 规划很重要——AquaWorks 补充沿既定路线、可重复、与位置关联的观测。",
    "cta": "阅读科学背景"
  },
  "sdgs": {
    "title": "我们对齐的可持续发展目标",
    "items": {
      "education": "优质教育",
      "water": "清洁饮水与卫生设施",
      "innovation": "产业、创新与基础设施",
      "cities": "可持续城市和社区",
      "consumption": "负责任消费和生产",
      "climate": "气候行动",
      "lifeBelowWater": "水下生物",
      "partnerships": "促进目标实现的伙伴关系"
    }
  },
  "cta": {
    "title": "一起打造可复用的校园监测平台。",
    "body": "工程与商科学生正在共同推进 AquaWorks。加入子团队、提供方法建议，或关注建造日志。",
    "button": "联系我们"
  }
}
